import React from 'react';
import { useTranslation } from 'react-i18next';
import { AlertCircle } from 'lucide-react';
import { ServiceType } from '../../types/api';

interface FAQSectionProps {
  serviceType: ServiceType;
}

const FAQSection: React.FC<FAQSectionProps> = ({ serviceType }) => {
  const { t } = useTranslation();

  const renderFAQContent = () => {
    if (serviceType === 'flower') {
      return (
        <>
          <div>
            <h3 className="text-sm font-medium text-gray-800">{t('subscription.plansSection.flowerFaq1q')}</h3>
            <p className="text-xs text-gray-600 mt-1">{t('subscription.plansSection.flowerFaq1a')}</p>
          </div>
          <div>
            <h3 className="text-sm font-medium text-gray-800">{t('subscription.plansSection.flowerFaq2q')}</h3>
            <p className="text-xs text-gray-600 mt-1">{t('subscription.plansSection.flowerFaq2a')}</p>
          </div>
          <div>
            <h3 className="text-sm font-medium text-gray-800">{t('subscription.plansSection.flowerFaq3q')}</h3>
            <p className="text-xs text-gray-600 mt-1">{t('subscription.plansSection.flowerFaq3a')}</p>
          </div>
        </>
      );
    } else if (serviceType === 'fruit') {
      return (
        <>
          <div>
            <h3 className="text-sm font-medium text-gray-800">{t('subscription.plansSection.fruitFaq1q')}</h3>
            <p className="text-xs text-gray-600 mt-1">{t('subscription.plansSection.fruitFaq1a')}</p>
          </div>
          <div>
            <h3 className="text-sm font-medium text-gray-800">{t('subscription.plansSection.fruitFaq2q')}</h3>
            <p className="text-xs text-gray-600 mt-1">{t('subscription.plansSection.fruitFaq2a')}</p>
          </div>
          <div>
            <h3 className="text-sm font-medium text-gray-800">{t('subscription.plansSection.fruitFaq3q')}</h3>
            <p className="text-xs text-gray-600 mt-1">{t('subscription.plansSection.fruitFaq3a')}</p>
          </div>
        </>
      );
    } else if (serviceType === 'cat_grass') {
      return (
        <>
          <div>
            <h3 className="text-sm font-medium text-gray-800">{t('subscription.plansSection.catGrassFaq1q')}</h3>
            <p className="text-xs text-gray-600 mt-1">{t('subscription.plansSection.catGrassFaq1a')}</p>
          </div>
          <div>
            <h3 className="text-sm font-medium text-gray-800">{t('subscription.plansSection.catGrassFaq2q')}</h3>
            <p className="text-xs text-gray-600 mt-1">{t('subscription.plansSection.catGrassFaq2a')}</p>
          </div>
          <div>
            <h3 className="text-sm font-medium text-gray-800">{t('subscription.plansSection.catGrassFaq3q')}</h3>
            <p className="text-xs text-gray-600 mt-1">{t('subscription.plansSection.catGrassFaq3a')}</p>
          </div>
        </>
      );
    } else {
      return (
        <div>
          <p className="text-xs text-gray-600">{t('subscription.faq.selectServiceTypeMessage')}</p>
        </div>
      );
    }
  };

  return (
    <div className="bg-white mt-2 px-5 py-4 rounded-xl shadow-sm">
      <div className="flex items-center mb-4">
        <AlertCircle size={20} className="text-gray-500 mr-2" />
        <span className="text-base font-medium text-gray-900">{t('subscription.plansSection.faqTitle')}</span>
      </div>
      
      <div className="space-y-4">
        {renderFAQContent()}
      </div>
    </div>
  );
};

export default FAQSection; 